import { CircularProgress, Stack, Typography } from '@mui/material';
import { LogoMangoIcon } from '~/shared/icons/LogoMangoIcon';

export const Logout = () => {
  return (
    <div>
      <Stack
        display="flex"
        flexDirection="column"
        alignItems="center"
        padding={25}
        gap={8}>
        <Stack display="flex" flexDirection="row" gap={1} alignItems="center">
          <LogoMangoIcon />
          <Typography component="h1" fontSize="64px" fontWeight={700}>
            Вы вышли из Mango CPA
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
};
